// Small formatting + presentation helpers.
export const formatCurrency = (n, opts = {}) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: opts.decimals ?? 0,
    minimumFractionDigits: opts.decimals ?? 0,
  }).format(n ?? 0);

export const formatNumber = (n) => new Intl.NumberFormat("en-US").format(n ?? 0);

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const diff = Date.now() - new Date(iso).getTime();
  const days = Math.round(diff / 86400000);
  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 30) return `${days}d ago`;
  const months = Math.round(days / 30);
  return `${months}mo ago`;
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

// status -> tailwind classes + label
export const STATUS_STYLES = {
  active: { label: "Active", cls: "bg-lux-emerald/15 text-lux-emerald border-lux-emerald/30" },
  pending: { label: "Pending", cls: "bg-gold/15 text-gold border-gold/30" },
  hold: { label: "On Hold", cls: "bg-amber-500/15 text-amber-500 border-amber-500/30" },
  onforce: { label: "On Force", cls: "bg-amber-500/15 text-amber-500 border-amber-500/30" },
  rejected: { label: "Rejected", cls: "bg-destructive/15 text-destructive border-destructive/30" },
  // subscriptions
  trialing: { label: "Trialing", cls: "bg-indigo-500/15 text-indigo-400 border-indigo-500/30" },
  past_due: { label: "Past Due", cls: "bg-amber-500/15 text-amber-500 border-amber-500/30" },
  canceled: { label: "Canceled", cls: "bg-destructive/15 text-destructive border-destructive/30" },
  paid: { label: "Paid", cls: "bg-lux-emerald/15 text-lux-emerald border-lux-emerald/30" },
  refunded: { label: "Refunded", cls: "bg-destructive/15 text-destructive border-destructive/30" },
  // demo
  new: { label: "New", cls: "bg-lux-emerald/15 text-lux-emerald border-lux-emerald/30" },
  contacted: { label: "Contacted", cls: "bg-gold/15 text-gold border-gold/30" },
  scheduled: { label: "Scheduled", cls: "bg-indigo-500/15 text-indigo-400 border-indigo-500/30" },
  completed: { label: "Completed", cls: "bg-muted text-muted-foreground border-border" },
};
